// @flow

import uuid from 'uuid/v4';
import * as R from 'ramda';

import { NOTIFICATIONS_LIST } from '~/gql';

export const resolvers = {
  Mutation: {
    createNotificationMutation: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      { values }: NotificationCreateInputMutation,
      { cache }: ApolloCache,
    ): Promise<MessagePayload> => {
      const { notificationsList }: NotificationsListQuery = cache.readQuery({
        query: NOTIFICATIONS_LIST,
      });

      const notification = {
        id: uuid(),
        delayInterval: 4e3,
        type: 'success',
        ...values,
        __typename: 'NotificationsListItem',
      };

      if (notification) {
        cache.writeData({
          data: {
            notificationsList: R.append(notification, notificationsList || []),
          },
        });
      }

      return {
        code: 0,
        message: 'Done',
        __typename: 'MessagePayload',
      };
    },
    deleteNotificationMutation: async (
      // $FlowIssue
      _, // eslint-disable-line no-unused-vars
      { notificationId }: NotificationDeleteInputMutation,
      { cache }: ApolloCache,
    ): Promise<MessagePayload> => {
      const { notificationsList }: NotificationsListQuery = cache.readQuery({
        query: NOTIFICATIONS_LIST,
      });

      // Try to find notification by id
      const notification = R.find(R.propEq('id', notificationId))(
        notificationsList || [],
      );

      if (notification) {
        cache.writeData({
          data: {
            notificationsList: R.without(
              [notification],
              notificationsList || [],
            ),
          },
        });
      }

      return {
        code: 0,
        message: 'Done',
        __typename: 'MessagePayload',
      };
    },
  },
};
